import * as yup from 'yup';
import { PaymentSystemType } from '../../../types';

export interface FeeScheduleFormValues {
  entityId: number | null;
  paymentType: string;
  paymentSystem: PaymentSystemType | null;
  price: number | null;
  enabled: boolean;
  notes: string;
}

export const DEFAULT_FEE_SCHEDULE_FORM_VALUES: FeeScheduleFormValues = {
  entityId: null,
  paymentType: '',
  paymentSystem: null,
  price: null,
  enabled: true,
  notes: '',
};

export const FeeScheduleValidationSchema = yup.object({
  entityId: yup.number().nullable().required('Entity is required'),
  paymentType: yup.string().required('Payment type is required'),
  paymentSystem: yup
    .string()
    .oneOf(Object.values(PaymentSystemType), 'Invalid payment system')
    .required('Payment system is required'),
  price: yup
    .number()
    .typeError('Price must be a number')
    .required('Price is required')
    .min(0, 'Price must not be negative')
    .test(
      'is-finite',
      'Price must be a valid number',
      value => value == null || isFinite(value),
    ),
  enabled: yup.boolean().defined(),
  notes: yup.string().defined(),
}) as yup.ObjectSchema<FeeScheduleFormValues>;
